import { styled } from 'mz-ui-kit'


export const Form = styled('form', {
  width: '100%',
  margin: '0 auto',
  maxWidth: '920px',
  transition: 'height 0.3s ease',
  transform: 'translate3d(0,0,0)',
  position: 'relative',
  zIndex: 6000,
})
